import { AvailabilityToDisplay } from 'services/userPreferences/types';
import { availability, sourcingDetails } from 'services/cart/types';
import {
  ProductAvailabilityBackorder,
  ProductAvailabilityByDate,
  ProductAvailabilityBySource
} from '.';
import { LocationAddress } from 'services/location/types';

export interface ProductAvailabilityProps {
  sourcingDetails?: sourcingDetails[];
  availability?: availability[];
  availabilityToDisplay?: AvailabilityToDisplay;
  isBackorder?: boolean;
  isCompact?: boolean;
  shouldWrap?: boolean;
  storeAddress?: LocationAddress;
}

export function ProductAvailability({
  sourcingDetails,
  availability,
  availabilityToDisplay,
  storeAddress,
  isBackorder = false,
  isCompact = false,
  shouldWrap = false
}: Readonly<ProductAvailabilityProps>) {
  if (isBackorder || (!sourcingDetails?.length && availability?.length)) {
    return (
      <ProductAvailabilityBackorder
        availability={availability}
        isCompact={isCompact}
        shouldWrap={shouldWrap}
        storeAddress={storeAddress}
      />
    );
  }

  if (availabilityToDisplay === 'D') {
    return (
      <ProductAvailabilityByDate
        sourcingDetails={sourcingDetails}
        isCompact={isCompact}
        shouldWrap={shouldWrap}
      />
    );
  }

  return (
    <ProductAvailabilityBySource
      sourcingDetails={sourcingDetails}
      isCompact={isCompact}
      shouldWrap={shouldWrap}
    />
  );
}
